import { createSlice } from "@reduxjs/toolkit"
import { LocalStorage } from "@/helpers/LocalStorage.ts"
import { FullScreen, NavigationBarPosition, Scale, Theme } from "@/appTypes/uiPreferences.ts"

export type UiPreferences = {
  theme: Theme
  scale: Scale
  navigationBarPosition: NavigationBarPosition
  fullScreen: FullScreen
}
const initialState: UiPreferences = {
  theme: LocalStorage.getSecret("theme") ?? "dark",
  scale: LocalStorage.getSecret("scale") ?? "medium",
  navigationBarPosition: LocalStorage.getSecret("navigationBarPosition")?? "top",
  fullScreen: false,
}
export const uiPreferences = createSlice({
  name: "uiPreferences",
  initialState,
  reducers: {
    toggleTheme: (state: UiPreferences) => {
      if (state.theme === "light") {
        state.theme = "dark"
        LocalStorage.setSecret("theme", "dark")
      } else {
        state.theme = "light"
        LocalStorage.setSecret("theme", "light")
      }
    },
    toggleScale: (state: UiPreferences) => {
      if (state.scale === "medium") {
        state.scale = "large"
        LocalStorage.setSecret("scale", "large")
      } else {
        state.scale = "medium"
        LocalStorage.setSecret("scale", "medium")
      }
    },
    updateNavigationBarPosition:(state) => {
      if (state.navigationBarPosition === "top") {
        state.navigationBarPosition = "bottom"
        LocalStorage.setSecret("navigationBarPosition", "bottom")
      } else {
        state.navigationBarPosition = "top"
        LocalStorage.setSecret("navigationBarPosition", "top")
      }
    },
    toggleFullScreen: (state) => {
      state.fullScreen = !state.fullScreen
      LocalStorage.setSecret("fullScreen", !state.fullScreen)
    }
  },
})

export const { toggleTheme, toggleScale,updateNavigationBarPosition,toggleFullScreen } = uiPreferences.actions
export const uiPreferencesReducer = uiPreferences.reducer
